import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getProductPriceInMachine,
  getProductsInMachine,
  getProductsSoldInMachine,
  getProductsSoldPriceInMachine,
  getStatistics,
} from "data/server_apis/statisticsService";

export const getStatisticsThunk = createAsyncThunk(
  "statistics",
  async (machine, { rejectWithValue }) => {
    try {
      return (await getStatistics(machine)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getProductsInMachineThunk = createAsyncThunk(
  "getProductsInMachine",
  async ({ machine, page }, { rejectWithValue }) => {
    try {
      console.log("Page : ",page)
      return (await getProductsInMachine(machine, page)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getProductPriceInMachineThunk = createAsyncThunk(
  "getProductPriceInMachine",
  async (machine, { rejectWithValue }) => {
    try {
      return (await getProductPriceInMachine(machine)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getProductsSoldInMachineThunk = createAsyncThunk(
  "getProductsSoldInMachine",
  async ({ machine, page, startDate, endDate  }, { rejectWithValue }) => {
    try {
      return (await getProductsSoldInMachine(machine, page, startDate, endDate)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getProductSoldPriceInMachineThunk = createAsyncThunk(
  "getProductSoldPriceInMachine",
  async ({ machine, startDate, endDate }, { rejectWithValue }) => {
    try {
      return (await getProductsSoldPriceInMachine(machine, startDate, endDate)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const statisticsSlice = createSlice({
  name: "statistics",
  initialState: {
    status: {},
    item: null,
    productsInMachine: [],
    productsInMachineStatus: {},
    productsInMachinePageSize: 1,
    productPriceInMachine: 0.0,

    productsSoldInMachine: [],
    productsSoldInMachineStatus: {},
    productsSoldInMachinePageSize: 1,
    productSoldPriceInMachine: 0.0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatisticsThunk.pending, (state, action) => {
      state.status = { loading: "get" };
    });
    builder.addCase(getStatisticsThunk.fulfilled, (state, action) => {
      state.status = { success: "get" };
      state.item = action.payload;
    });
    builder.addCase(getStatisticsThunk.rejected, (state, action) => {
      state.status = { error: "get", error_message: action.payload?.message };
    });

    builder.addCase(getProductsInMachineThunk.pending, (state, action) => {
      state.productsInMachineStatus = { loading: "get" };
    });
    builder.addCase(getProductsInMachineThunk.fulfilled, (state, action) => {
      state.productsInMachineStatus = { success: "get" };
      state.productsInMachinePageSize = action.payload.total_pages;
      state.productsInMachine = action.payload.results;
    });
    builder.addCase(getProductsInMachineThunk.rejected, (state, action) => {
      state.productsInMachineStatus = {
        error: "get",
        error_message: action.payload?.message,
      };
    });

    builder.addCase(
      getProductPriceInMachineThunk.fulfilled,
      (state, action) => {
        console.log("getProductPriceInMachineThunk", action.payload);
        state.productPriceInMachine = action.payload.total_price;
      }
    );

    builder.addCase(getProductsSoldInMachineThunk.pending, (state, action) => {
      state.productsSoldInMachineStatus = { loading: "get" };
    });
    builder.addCase(getProductsSoldInMachineThunk.fulfilled, (state, action) => {
      state.productsSoldInMachineStatus = { success: "get" };
      state.productsSoldInMachinePageSize = action.payload.total_pages;
      state.productsSoldInMachine = action.payload.results;
    });
    builder.addCase(getProductsSoldInMachineThunk.rejected, (state, action) => {
      state.productsSoldInMachineStatus = {
        error: "get",
        error_message: action.payload?.message,
      };
    });

    builder.addCase(
      getProductSoldPriceInMachineThunk.fulfilled,
      (state, action) => {
        // console.log("getProductPriceInMachineThunk", action.payload);
        state.productSoldPriceInMachine = action.payload.total_price;
      }
    );
  },
});

export const {} = statisticsSlice.actions;

export default statisticsSlice.reducer;
